/**
 * Created by rudi on 07/02/14.
 */

OLIVIO.ClampLine = function (draw, downCallBack) {

  var self = this;

  this.downCallBack = downCallBack;

  this.draw = draw;

  this.mode = -1;

  this.topPos = 0;
  this.bottomPos = 1000;
  this.mousePos = 0;
  this.targetTopPos = 0;
  this.targetBottomPos = 1000;
  this.clampWidth = 700;
  this.draw = draw;
  this.topClickAreaHeight = 200;

  this.topLineWidth = OLIVIO.ClampLine.LINEWIDTHINACTIVE;
  this.bottomLineWidth = OLIVIO.ClampLine.LINEWIDTHINACTIVE;

  this.lineTop = draw.line(0, 0, this.clampWidth, 0).stroke({ width: OLIVIO.ClampLine.LINEWIDTHINACTIVE });
  this.lineBottom = draw.line(0, 0, this.clampWidth, 0).stroke({ width: OLIVIO.ClampLine.LINEWIDTHINACTIVE });
  this.lineConnection = draw.line(1000, 0, 1000, 1).stroke({ width: OLIVIO.ClampLine.LINEWIDTHACTIVE });
  this.rectTop = draw.rect(40, 40);
  this.rectBottom = draw.rect(40, 40);

  this.clickAreaRight = draw.rect(200, 200);
  //OLIVIO.debug = true;
  this.clickAreaRight.fill({ color: '#ff0000', opacity: (OLIVIO.debug ? 0.1 : 0.0) });

  this.clickAreaTop = draw.rect(200, 200);
  this.clickAreaBottom = draw.rect(200, 200);
  this.clickAreaTop.fill({ color: '#00ff00', opacity: (OLIVIO.debug ? 0.1 : 0.0) });
  this.clickAreaBottom.fill({ color: '#0000ff', opacity: (OLIVIO.debug ? 0.1 : 0.0) });


  this.clampMinHeight = 0;

  this.mastLines = [];
  this.mastLineTexts = [];


  this.downTop = function (e) {
    self.mousePos = self.topPos;
    self.targetTopPos = self.topPos;
    if (self.mode === OLIVIO.ClampLine.MODELUM) {
      OLIVIO.cmodel.startArrangingLumPositions();
    }
    downCallBack(e, OLIVIO.ClampLine.AREATOP);
  };
  this.downBottom = function (e) {
    self.mousePos = self.bottomPos;
    self.targetBottomPos = self.bottomPos;
    if (self.mode === OLIVIO.ClampLine.MODELUM) {
      OLIVIO.cmodel.startArrangingLumPositions();
    }
    self.downCallBack(e, OLIVIO.ClampLine.AREABOTTOM);
  };

  this.downRight = function (e) {
    self.mousePos = self.topPos;
    self.targetTopPos = self.topPos;
    if (self.mode === OLIVIO.ClampLine.MODELUM) {
      OLIVIO.cmodel.startArrangingLumPositions();
    }
    self.downCallBack(e, OLIVIO.ClampLine.AREARIGHT);
  };

  if (self.downCallBack) {
    //console.log("blaaaaaaaaaaaaaaaa");
    NeoUtils.addDownHandler(this.clickAreaTop.node,this.downTop);
    NeoUtils.addDownHandler(this.clickAreaBottom.node,this.downBottom);
    NeoUtils.addDownHandler(this.clickAreaRight.node,this.downRight);
    this.clickAreaTop.node.style.cursor = 'pointer';
    this.clickAreaBottom.node.style.cursor = 'pointer';
    this.clickAreaRight.node.style.cursor = 'pointer';
  }

  this.unBindHandlers = function () {
    if (self.downCallBack) {
      NeoUtils.removeDownMoveUpHandlers(this.clickAreaTop.node,this.downTop);
      NeoUtils.removeDownMoveUpHandlers(this.clickAreaBottom.node,this.downBottom);
      NeoUtils.removeDownMoveUpHandlers(this.clickAreaRight.node,this.downRight);
    }
  };

  // [12000,10000,9000,8000,7000,5800,4800], pole.worldHeight(), mm, mm, world
  this.initClamp = function () {
    //this.clampMinHeight = (OLIVIO.cmodel.minLumDistancemm - 10) * OLIVIO.cmodel.mmToWorldUnit;
    this.clampMinHeight = 0;
    this.removeMastSizes();
  };

  this.drawMastSizes = function () {
    this.removeMastSizes();
    for (var i = 0; i < OLIVIO.cmodel.mastSizesWorld.length; i++) {
      // hack clampline offset into design
      var offset = 0;
      if (OLIVIO.cmodel.product === OLIVIO.PRODUCT_CANDELABRA) {
        offset = (i === 0) ? 290 : 230;
      }
      this.mastLines[i] = this.draw.line(OLIVIO.cmodel.clampPosX, OLIVIO.cmodel.scaledMastHeightWorldMax - OLIVIO.cmodel.scaledMastSizesWorld[i] + offset, OLIVIO.cmodel.clampPosX + OLIVIO.ClampLine.CLAMPWIDTHPOLE, OLIVIO.cmodel.scaledMastHeightWorldMax - OLIVIO.cmodel.scaledMastSizesWorld[i] + offset).stroke({ width: 5 });
      this.mastLineTexts[i] = OLIVIO.getSVGText(this.draw, OLIVIO.cmodel.mastSizesmm[i] + 'mm').move(OLIVIO.cmodel.clampPosX + 100 + OLIVIO.ClampLine.CLAMPWIDTHPOLE, OLIVIO.cmodel.scaledMastHeightWorldMax - OLIVIO.cmodel.scaledMastSizesWorld[i] + offset);
    }
  };

  this.removeMastSizes = function () {
    for (var i = 0; i < this.mastLines.length; i++) {
      this.mastLines[i].remove();
      this.mastLines[i] = null;
    }
    for (var j = 0; j < this.mastLineTexts.length; j++) {
      this.mastLineTexts[j].remove();
      this.mastLineTexts[j] = null;
    }
    this.mastLines = [];
    this.mastLineTexts = [];
  };

  this.setMode = function (mode) {

    if (this.mode === mode) {
      return;
    }

    TweenLite.killTweensOf(this);

    this.mode = mode;
    if (this.mode === OLIVIO.ClampLine.MODEPOLE) {
      this.drawMastSizes();
      this.topClickAreaHeight = 300;
      this.lineTop.show();
      this.lineBottom.show();
      this.lineConnection.show();
      this.rectTop.show();
      this.rectBottom.show();
      this.clickAreaTop.show();

      this.clickAreaRight.hide();
      this.clickAreaBottom.hide();

      this.clampWidth = OLIVIO.ClampLine.CLAMPWIDTHPOLE;
      this.topLineWidth = OLIVIO.ClampLine.LINEWIDTHACTIVE;
      this.bottomLineWidth = OLIVIO.ClampLine.LINEWIDTHINACTIVE;
      this.setTopAndBottomPos(OLIVIO.cmodel.mastHeightWorldMax - OLIVIO.cmodel.mastHeightWorld, OLIVIO.cmodel.mastHeightWorldMax);

    } else if (this.mode === OLIVIO.ClampLine.MODELUM) {
      this.removeMastSizes();
      this.topClickAreaHeight = 200;
      this.lineTop.show();
      this.lineBottom.show();
      this.lineConnection.show();
      this.rectTop.show();
      this.rectBottom.show();
      this.clickAreaTop.show();
      this.clickAreaBottom.show();

      this.clickAreaRight.show();

      this.clampWidth = OLIVIO.ClampLine.CLAMPWIDTHLUM;
      this.topLineWidth = OLIVIO.ClampLine.LINEWIDTHINACTIVE;
      this.bottomLineWidth = OLIVIO.ClampLine.LINEWIDTHINACTIVE;
      this.setTopAndBottomPos(OLIVIO.cmodel.topLumPositionWorld, OLIVIO.cmodel.bottomLumPositionWorld);


    } else {
      this.removeMastSizes();

      this.lineTop.hide();
      this.lineBottom.hide();
      this.lineConnection.hide();
      this.rectTop.hide();
      this.rectBottom.hide();
      this.clickAreaTop.hide();
      this.clickAreaBottom.hide();

      this.clickAreaRight.hide();
    }

    if (this.lineTop.visible()) {
      this.lineTop.remove();
      this.lineTop = this.draw.line(0, 0, this.clampWidth, 0).stroke({ width: this.topLineWidth });
    }

    if (this.lineTop.visible()) {
      this.lineBottom.remove();
      this.lineBottom = draw.line(0, 0, this.clampWidth, 0).stroke({ width: this.bottomLineWidth });
    }

    if (self.downCallBack) {
      this.clickAreaTop.node.style.cursor = 'ns-resize';
      this.clickAreaBottom.node.style.cursor = 'ns-resize';
      this.clickAreaRight.node.style.cursor = 'ns-resize';
    }

    this.redraw();
  };

  this.updateClamp = function () {
    if (this.mode === OLIVIO.ClampLine.MODEPOLE) {
      TweenLite.killTweensOf(this);
      //this.setTopAndBottomPos(OLIVIO.cmodel.mastHeightWorldMax - OLIVIO.cmodel.mastHeightWorld, OLIVIO.cmodel.mastHeightWorldMax);
      //this.redraw();
      this.targetTopPos = (OLIVIO.cmodel.scaledMastHeightWorldMax - OLIVIO.cmodel.scaledMastHeightWorld);
      this.targetBottomPos = OLIVIO.cmodel.scaledMastHeightWorldMax;
      this.bottomPos = OLIVIO.cmodel.scaledMastHeightWorldMax;
      var moveTop = function (target) {
        //OLIVIO.cmodel.mastHeightWorld = OLIVIO.cmodel.mastHeightWorldMax-target.topPos;
        //target.updateLumBoundaries();
        target.redraw();
      };
      TweenLite.to(this, 0.3, {topPos: this.targetTopPos, onUpdate: moveTop, onUpdateParams: [this]});
    } else if (this.mode === OLIVIO.ClampLine.MODELUM) {
      TweenLite.killTweensOf(this);
      this.setTopAndBottomPos(OLIVIO.cmodel.topLumPositionWorld, OLIVIO.cmodel.bottomLumPositionWorld);
      //this.redraw();
    }
  };

  this.setTopAndBottomPos = function (topPos, bottomPos) {
    this.topPos = topPos * OLIVIO.cmodel.mastScale;
    this.targetTopPos = topPos * OLIVIO.cmodel.mastScale;
    this.bottomPos = bottomPos * OLIVIO.cmodel.mastScale;
    this.targetBottomPos = bottomPos * OLIVIO.cmodel.mastScale;
    this.redraw();
  };


  this.redraw = function () {
    if (this.mode === OLIVIO.ClampLine.MODENONE) {
      return;
    }
    // hack clampline offset into design
    var offset = 0;
    if (OLIVIO.cmodel.product === OLIVIO.PRODUCT_CANDELABRA) {
      offset = (OLIVIO.cmodel.mastSizeIndex === 0) ? 290 : 230;
    }
    this.lineTop.move(OLIVIO.cmodel.clampPosX, this.topPos + (this.topLineWidth * 0.5) + offset);
    this.lineBottom.move(OLIVIO.cmodel.clampPosX, this.bottomPos - (this.bottomLineWidth * 0.5));
    this.lineConnection.remove();
    this.lineConnection = this.draw.line(OLIVIO.cmodel.clampPosX + this.clampWidth, this.topPos + offset, OLIVIO.cmodel.clampPosX + this.clampWidth, this.bottomPos).stroke({ width: OLIVIO.ClampLine.LINEWIDTHACTIVE });
    this.rectTop.move(OLIVIO.cmodel.clampPosX + this.clampWidth - 20, this.topPos + offset);
    this.rectBottom.move(OLIVIO.cmodel.clampPosX + this.clampWidth - 20, this.bottomPos - 40);
    this.clickAreaTop.size(this.clampWidth + 500, this.topClickAreaHeight);
    this.clickAreaTop.move(OLIVIO.cmodel.clampPosX - 400, this.topPos - 100 + offset);
    // this.clickAreaTop.move(OLIVIO.cmodel.clampPosX+this.clampWidth-100,this.topPos-100);
    this.clickAreaBottom.size(this.clampWidth + 500, 200);
    this.clickAreaBottom.move(OLIVIO.cmodel.clampPosX - 400, this.bottomPos - 100);
    var rightHeight = this.bottomPos - this.topPos + 200 + offset;
    this.clickAreaRight.size(OLIVIO.cmodel.clampPosX + 500, rightHeight);
    this.clickAreaRight.move(OLIVIO.cmodel.clampPosX, ((this.bottomPos - this.topPos) * 0.5) - (rightHeight * 0.5) + this.topPos);

  };

  this.setWhite = function () {
    this.lineTop.fill({ color: '#ffffff'});
    this.lineBottom.fill({ color: '#ffffff'});
    this.lineConnection.fill({ color: '#ffffff'});
    this.rectTop.fill({ color: '#ffffff'});
    this.rectBottom.fill({ color: '#ffffff'});
    this.clickAreaTop.fill({ color: '#ffffff', opacity: 0.0});
    this.clickAreaBottom.fill({ color: '#ffffff', opacity: 0.0});
    this.clickAreaRight.fill({ color: '#ffffff', opacity: 0.0});
    this.lineTop.stroke({ color: '#ffffff'});
    this.lineBottom.stroke({ color: '#ffffff'});
    this.lineConnection.stroke({ color: '#ffffff'});
    this.rectTop.stroke({ color: '#ffffff'});
    this.rectBottom.stroke({ color: '#ffffff'});

    for (var i = 0; i < this.mastLines.length; i++) {
      this.mastLines[i].stroke({ color: '#ffffff'});
    }
    for (var j = 0; j < this.mastLineTexts.length; j++) {
      this.mastLineTexts[j].fill({ color: '#ffffff'});
    }
    //this.clickAreaTop.stroke({ color: '#ffffff'});
    //this.clickAreaBottom.stroke({ color: '#ffffff'});
    //this.clickAreaRight.stroke({ color: '#ffffff'});
  };

  this.moveBy = function (currentClampId, deltaY) {

    this.mousePos += deltaY;
    var moveTo = this.mousePos;

    if (this.mode === OLIVIO.ClampLine.MODEPOLE) {
      if (currentClampId === OLIVIO.ClampLine.AREATOP) {
        var bestIndex = 0;
        if (moveTo < 0) {
          moveTo = 0;
        } else if (moveTo > OLIVIO.cmodel.scaledMastHeightWorldMax - OLIVIO.cmodel.scaledMastSizesWorld[OLIVIO.cmodel.scaledMastSizesWorld.length - 1]) {
          bestIndex = (OLIVIO.cmodel.mastSizesmm.length - 1);
          moveTo = OLIVIO.cmodel.scaledMastHeightWorldMax - OLIVIO.cmodel.scaledMastSizesWorld[OLIVIO.cmodel.scaledMastSizesWorld.length - 1];
        } else {
          // snap by finding nearest value in OLIVIO.cmodel.mastSizesWorld

          var bestWorldDistance = Number.POSITIVE_INFINITY;
          for (var i = 0; i < OLIVIO.cmodel.scaledMastSizesWorld.length; i++) {
            var worldPos = OLIVIO.cmodel.scaledMastHeightWorldMax - OLIVIO.cmodel.scaledMastSizesWorld[i];
            var worldDistance = Math.abs(worldPos - moveTo);
            if (worldDistance < bestWorldDistance) {
              bestWorldDistance = worldDistance;
              bestIndex = i;
            }
          }
          moveTo = OLIVIO.cmodel.scaledMastHeightWorldMax - OLIVIO.cmodel.scaledMastSizesWorld[bestIndex];
        }

        if (this.targetTopPos !== moveTo) {
          this.targetTopPos = moveTo;
          OLIVIO.cmodel.setMastHeightByIndex(bestIndex, true);
          var moveTop = function (target) {
            //OLIVIO.cmodel.mastHeightWorld = OLIVIO.cmodel.mastHeightWorldMax-target.topPos;
            //target.updateLumBoundaries();
            target.redraw();
          };
          TweenLite.to(this, 0.3, {topPos: this.targetTopPos, onUpdate: moveTop, onUpdateParams: [this]});
        }
      } else if (currentClampId === OLIVIO.ClampLine.AREABOTTOM) {

      } else if (currentClampId === OLIVIO.ClampLine.AREARIGHT) {

      }

    } else if (this.mode === OLIVIO.ClampLine.MODELUM) {

      if (currentClampId === OLIVIO.ClampLine.AREATOP) {
        if (moveTo < OLIVIO.cmodel.topLumBoundaryWorld) {
          moveTo = OLIVIO.cmodel.topLumBoundaryWorld;
        } else if (moveTo > this.bottomPos - this.clampMinHeight) {
          moveTo = this.bottomPos - this.clampMinHeight;
        }
        if (this.targetTopPos !== moveTo) {
          this.targetTopPos = moveTo;
          this.topPos = this.targetTopPos;
          this.redraw();
          OLIVIO.cmodel.arrangeLumPositions(this.topPos, this.bottomPos, currentClampId); // 0 === currentClampId === OLIVIO.ClampLine.AREATOP
        }

      } else if (currentClampId === OLIVIO.ClampLine.AREABOTTOM) {

        if (moveTo < this.topPos + this.clampMinHeight) {
          moveTo = this.topPos + this.clampMinHeight;
        } else if (moveTo > OLIVIO.cmodel.bottomLumBoundaryWorld) {
          moveTo = OLIVIO.cmodel.bottomLumBoundaryWorld;
        }
        if (this.targetBottomPos !== moveTo) {
          this.targetBottomPos = moveTo;
          this.bottomPos = this.targetBottomPos;
          this.redraw();
          OLIVIO.cmodel.arrangeLumPositions(this.topPos, this.bottomPos, currentClampId); // 1 === currentClampId === OLIVIO.ClampLine.AREABOTTOM
        }

      } else if (currentClampId === OLIVIO.ClampLine.AREARIGHT) {
        if (moveTo < OLIVIO.cmodel.topLumBoundaryWorld) {
          moveTo = OLIVIO.cmodel.topLumBoundaryWorld;
        } else if (moveTo > OLIVIO.cmodel.bottomLumBoundaryWorld - (this.bottomPos - this.topPos)) {
          moveTo = OLIVIO.cmodel.bottomLumBoundaryWorld - (this.bottomPos - this.topPos);
        }
        if (this.targetTopPos !== moveTo) {
          var delta = this.targetTopPos - moveTo;
          this.targetTopPos = moveTo;
          this.topPos = this.targetTopPos;
          this.targetBottomPos = this.targetBottomPos - delta;
          this.bottomPos = this.targetBottomPos;
          this.redraw();
          OLIVIO.cmodel.arrangeLumPositions(this.topPos, this.bottomPos, currentClampId); // 2 === currentClampId === OLIVIO.ClampLine.AREARIGHT
        }

      }

    }


  };

};

OLIVIO.ClampLine.MODENONE = 0;
OLIVIO.ClampLine.MODEPOLE = 1;
OLIVIO.ClampLine.MODELUM = 2;

OLIVIO.ClampLine.AREATOP = 0;
OLIVIO.ClampLine.AREABOTTOM = 1;
OLIVIO.ClampLine.AREARIGHT = 2;

OLIVIO.ClampLine.CLAMPWIDTHPOLE = 650;
OLIVIO.ClampLine.CLAMPWIDTHLUM = 450;

OLIVIO.ClampLine.LINEWIDTHINACTIVE = 1;
OLIVIO.ClampLine.LINEWIDTHACTIVE = 5;
